import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeftDownCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-left-down-circle"><path d="M12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 9.75V15.25H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.2501 8.75L9.43066 14.5694" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowLeftDownCircle;
